'use client';

import Button from '@/components/Button';
import Cards from '@/components/Cards';
import CustomLink from '@/components/CustomLink';
import SectionTitle from '@/components/SectionTitle';
import Subheader from '@/components/Subheader';
import { useConfig } from '@/app/contexts/ConfigContext';
import { SERVICE_TYPES } from '@/helpers/enums';
import { CardDefinition, ServiceType } from '@/types';

interface MediaProps {
  items: CardDefinition[][];
}

export default function MediaSectionMultiAstrologyMeditationLove({
  items,
}: MediaProps) {
  const { wording, config, setConfig, updateWording, selectedLanguage } =
    useConfig();

  const astrologyItems = items[0] ?? [];
  const meditationItems = items[1] ?? [];
  const loveItems = items[2] ?? [];

  const handleConfig = (type: ServiceType) => {
    setConfig({
      ...config,
      serviceType: type,
    });
    updateWording(type, selectedLanguage);
  };

  return (
    <section className='sm:mb-32 mb-8'>
      <SectionTitle>{wording?.media_content_section_title}</SectionTitle>
      <div className='flex items-end justify-between items-center mt-4'>
        <Subheader>{wording?.media_content_section_multi_1_subheader_text}</Subheader>
        <Button
          variant='secondary'
          className='!px-1 py-2 w-[125px] sm:!w-[295px]'
          themeBackgroundColor={config.theme.textColorDark}
          themeTextColor={config.theme.textColorLight}
        >
          <CustomLink
            href='/media/media_all'
            onClick={() => {
              handleConfig(SERVICE_TYPES.ASTROLOGY);
            }}
          >
            {wording?.media_content_section_button_more}
          </CustomLink>
        </Button>
      </div>
      <Cards items={astrologyItems} serviceType={SERVICE_TYPES.ASTROLOGY} />

      <div className='flex items-end justify-between items-center mt-4'>
        <Subheader>{wording?.media_content_section_multi_2_subheader_text}</Subheader>
        <Button
          variant='secondary'
          className='!px-1 py-2 w-[125px] sm:!w-[295px]'
          themeBackgroundColor={config.theme.textColorDark}
          themeTextColor={config.theme.textColorLight}
        >
          <CustomLink
            href='/media/media_all'
            onClick={() => {
              handleConfig(SERVICE_TYPES.MEDITATION);
            }}
          >
            {wording?.media_content_section_button_more}
          </CustomLink>
        </Button>
      </div>
      <Cards items={meditationItems} serviceType={SERVICE_TYPES.MEDITATION} />

      <div className='flex items-end justify-between items-center mt-4'>
        <Subheader>{wording?.media_content_section_multi_3_subheader_text}</Subheader>
        <Button
          variant='secondary'
          className='!px-1 py-2 w-[125px] sm:!w-[295px]'
          themeBackgroundColor={config.theme.textColorDark}
          themeTextColor={config.theme.textColorLight}
        >
          <CustomLink
            href='/media/media_all'
            onClick={() => {
              handleConfig(SERVICE_TYPES.LOVE);
            }}
          >
            {wording?.media_content_section_button_more}
          </CustomLink>
        </Button>
      </div>
      <Cards items={loveItems} serviceType={SERVICE_TYPES.LOVE} />
    </section>
  );
}
